import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/productlist/FilterM";
import {FILTER_ALL} from ".";

interface Props {
	tagList: {code: string; name: string; divi: string}[];
	handleTagCheck: (checked: boolean, value: string) => void;
	dataStr: string;
}

const ProductFeatureComponent = ({tagList, handleTagCheck, dataStr}: Props) => {
	const featuresListData = dataStr.replaceAll("|", "").split("^");
	const featuresList: {code: string; name: string; divi: string}[] = [];
	for (let i = 0; i < featuresListData.length; i += 3) {
		const code = featuresListData[i];
		const name = featuresListData[i + 1];
		const divi = featuresListData[i + 2];
		featuresList.push({code, name, divi});
	}

	return (
		<style.CheckList>
			<style.CheckListItem>
				<input
					type="checkbox"
					id={`features-PC00`}
					onChange={e => handleTagCheck(e.target.checked, e.target.value)}
					checked={!tagList.length}
					value={FILTER_ALL}
				/>
				<label htmlFor={`features-PC00`}>
					<span>전체</span>
				</label>
			</style.CheckListItem>
			{featuresList.map((feature, idx) => (
				<style.CheckListItem key={idx}>
					<input
						type="checkbox"
						id={`features${feature.code}`}
						onChange={e => handleTagCheck(e.target.checked, e.target.value)}
						checked={tagList.some(e => e.code === feature.code)}
						value={JSON.stringify({...feature})}
					/>
					<label htmlFor={`features${feature.code}`}>
						<span>{feature.name}</span>
					</label>
				</style.CheckListItem>
			))}
		</style.CheckList>
	);
};

const ProductFeature = (props: Props) => (
	<ErrorBoundary logMsg="DetailFilter ProductFeature Error">
		<ProductFeatureComponent {...props} />
	</ErrorBoundary>
);

export default ProductFeature;
